import React from "react";
import IconHeader from "./IconHeader";
import ImageSlider from "./ImageSlider";

import "./Header.scss";

// [ [ desktopImage, mobileImage ], ... ]
const tuples = [
  [require("../assets/home_01.webp"), require("../assets/home_01_mobile.webp")],
  [require("../assets/home_02.webp"), require("../assets/home_02_mobile.webp")],
  [require("../assets/home_03.webp"), require("../assets/home_03_mobile.webp")],
  [require("../assets/home_04.webp"), require("../assets/home_04_mobile.webp")],
  [require("../assets/home_05.webp"), require("../assets/home_05_mobile.webp")],
  [require("../assets/home_06.webp"), require("../assets/home_06_mobile.webp")],
  [
    require("../assets/Another-Birthday_feature.webp"),
    require("../assets/Another-Birthday_mobile.webp"),
  ],
  [
    require("../assets/Bigger-Trees_feature.webp"),
    require("../assets/Bigger-Trees_mobile.webp"),
  ],
  [
    require("../assets/Midnight_feature.webp"),
    require("../assets/Midnight_mobile.webp"),
  ],
  [
    require("../assets/tlinh_feature.webp"),
    require("../assets/tlinh_mobile.webp"),
  ],
  [
    require("../assets/Waiting-Room_feature.webp"),
    require("../assets/Waiting-Room_mobile.webp"),
  ],
  [
    require("../assets/no_sweast.webp"),
    require("../assets/no_sweast_mobile.webp"),
  ],
  [
    require("../assets/Birds_01.webp"),
    require("../assets/Birds_01_mobile.webp"),
  ],
  [
    require("../assets/Holiday_Website.webp"),
    require("../assets/Holiday_Mobile.webp"),
  ],
  [require("../assets/MOiP-Desktop.gif"), require("../assets/MOiP-Mobile.gif")],
  [
    require("../assets/CNY25_MFKV.webp"),
    require("../assets/CNY25_MFKV_mobile.webp"),
  ],
  [require("../assets/CLAN.mp4"), require("../assets/CLAN_mobile.mp4")],
  [require("../assets/brasil.webp"), require("../assets/brasil_mobile.webp")],
  [require("../assets/0318.webp"), require("../assets/0318_mobile.webp")],
];

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export default function Header() {
  const images = React.useMemo(() => {
    return shuffleArray(tuples);
  }, [tuples]);

  return (
    <div style={{ position: "relative" }}>
      <ImageSlider images={images} />
      <div style={{ position: "absolute", top: 0, left: 0, width: "100%" }}>
        <IconHeader />
      </div>
    </div>
  );
}
